import {
  BoardSearchDetail,
  CalendarBox,
  CalendarIcon,
  ColSpan1,
  ColSpan2,
  ColSpan3,
  ColTitle,
  CustomDatePicker,
  DateContainer,
  Input,
  inputStyle,
  RangePicker,
  ResetButton,
  RowSpan,
  SearchButton
} from "../../assets/GlobalStyles";
import Select from "react-select";
import {defaultCondition} from "../../pages/reports/entity/common";
import ko from "date-fns/locale/ko";
import {HorizontalRule} from "../common/Common";
import React, {useEffect, useState} from "react";
import {
  getLastDay,
  getLastMonth,
  getLastNinetyDay,
  getLastThirtyDay,
  getLastWeekDay,
  getThisMonth,
  getToDay
} from "../../common/DateUtils";
import moment from "moment/moment";
import {confirmAlert} from "react-confirm-alert";
import {SearchUser} from "../common/SearchUser";
import {useAtomValue} from "jotai";
import {tokenResultAtom} from "../../pages/login/entity";
import styled from "styled-components";
import DashboardDateSelector from "../dashboard/DateSelector";
import {selKeywordUser} from "../../services/platform/ManageUserAxios";
import FilterCheckboxDropdown from "../common/FilterCheckboxDropdown";

const mainColor = "var(--color-main)";
const modernSelectStyle = {
  container: styles => ({...styles, width: "100%", minWidth: 0}),
  control: (styles, state) => ({
    ...styles,
    minHeight: 38,
    height: 38,
    borderColor: state.isFocused ? "var(--color-primary)" : "var(--color-border-strong)",
    borderRadius: 7,
    boxShadow: state.isFocused ? "0 0 0 3px rgba(59, 130, 246, .1)" : "none",
    fontSize: 13,
    cursor: "pointer",
    ":hover": {borderColor: "var(--color-primary-focus)"},
  }),
  valueContainer: styles => ({...styles, height: 38, padding: "0 11px"}),
  indicatorsContainer: styles => ({...styles, height: 38}),
  indicatorSeparator: () => ({display: "none"}),
  dropdownIndicator: styles => ({...styles, padding: "0 9px", color: "#7c8795"}),
  singleValue: styles => ({...styles, color: "var(--color-text)"}),
  placeholder: styles => ({...styles, color: "#a0a8b2"}),
  menu: styles => ({...styles, zIndex: 40, overflow: "hidden", border: "1px solid var(--color-border-strong)", borderRadius: 7, boxShadow: "0 10px 28px rgba(31, 41, 55, .12)"}),
  option: (styles, state) => ({
    ...styles,
    padding: "9px 11px",
    background: state.isSelected ? "var(--color-primary-soft)" : state.isFocused ? "#f7fbff" : "var(--color-surface)",
    color: state.isSelected ? "var(--color-primary-strong)" : "#4b5563",
    fontSize: 13,
  }),
};

export function ReportsCondition(props) {
  const {searchState, setSearchState, setChartPageSize, modalStyle, onSearch, searchMediaInfo, searchMedia, searchMediaReset, modern = false, inventoryOptions = [], showInventory = false, inventoryMulti = false, inventoryRequiresMedia = false, onMediaDraftChange} = props
  const [dateRange, setDateRange] = useState([ new Date(getThisMonth().startDay), new Date(getToDay())]);
  const [startDate, endDate] = dateRange
  const [, setIsCheckedAll] = useState(true)
  const [dayType, setDayType] = useState('thisMonth')
  const tokenInfoState = useAtomValue(tokenResultAtom)
  const [mediaOptions, setMediaOptions] = useState([{value: "", label: "전체", data: null}])
  const [modernMediaInfo, setModernMediaInfo] = useState(searchMediaInfo || {})

  useEffect(() => {
    if (!modern || tokenInfoState.role === "NORMAL") {
      return;
    }

    selKeywordUser("").then(response => {
      const mediaList = Array.isArray(response) ? response : [];
      setMediaOptions([
        {value: "", label: "전체", data: null},
        ...mediaList.map(item => ({
          value: item.id || item.username,
          label: item.siteName || item.username,
          data: item,
        }))
      ]);
    });
  }, [modern, tokenInfoState.role]);

  useEffect(() => {
    if (modern) {
      setModernMediaInfo(searchMediaInfo || {});
    }
  }, [modern, searchMediaInfo]);

  useEffect(() => {
    if (!dateRange[0] || !dateRange[1]) {
      return;
    }

    setSearchState(prev => ({
      ...prev,
      searchStartDate: moment(dateRange[0]).format('YYYY-MM-DD'),
      searchEndDate: moment(dateRange[1]).format('YYYY-MM-DD'),
    }));
  }, [dateRange, setSearchState]);

  useEffect(() => {
    if(searchState.agentType.length === defaultCondition.agentType.length) {
      setIsCheckedAll(true)
    } else {
      setIsCheckedAll(false)
    }
  }, [searchState]);

  /**
   * 날짜 레인지 선택
   * @param rangeType
   */
  const handleRangeDate = (rangeType) => {
    setDayType(rangeType)
    if (rangeType === 'thisMonth') {
      setSearchState({
        ...searchState,
        searchStartDate: getThisMonth().startDay,
        searchEndDate: getThisMonth().endDay
      })
      setDateRange([new Date(getThisMonth().startDay), new Date(getThisMonth().endDay)])
    } else if (rangeType === 'lastMonth') {
      setSearchState({
        ...searchState,
        searchStartDate: getLastMonth().startDay,
        searchEndDate: getLastMonth().endDay
      })
      setDateRange([new Date(getLastMonth().startDay), new Date(getLastMonth().endDay)])
    } else if (rangeType === 'today') {
      setSearchState({
        ...searchState,
        searchStartDate: getToDay(),
        searchEndDate: getToDay()
      })
      setDateRange([new Date(), new Date()])
    } else if (rangeType === 'lastDay') {
      setSearchState({
        ...searchState,
        searchStartDate: getLastDay(),
        searchEndDate: getLastDay()
      })
      setDateRange([new Date(getLastDay()), new Date(getLastDay())])
    } else if (rangeType === 'lastWeekDay') {
      setSearchState({
        ...searchState,
        searchStartDate: getLastWeekDay().startDay,
        searchEndDate: getLastWeekDay().endDay
      })
      setDateRange([new Date(getLastWeekDay().startDay), new Date(getLastWeekDay().endDay)])
    } else if (rangeType === 'lastThirtyDay') {
      setSearchState({
        ...searchState,
        searchStartDate: getLastThirtyDay().startDay,
        searchEndDate: getLastThirtyDay().endDay
      })
      setDateRange([new Date(getLastThirtyDay().startDay), new Date(getLastThirtyDay().endDay)])
    } else if (rangeType === 'lastNinetyDay') {
      setSearchState({
        ...searchState,
        searchStartDate: getLastNinetyDay().startDay,
        searchEndDate: getLastNinetyDay().endDay
      })
      setDateRange([new Date(getLastNinetyDay().startDay), new Date(getLastNinetyDay().endDay)])
      setChartPageSize !== undefined && setChartPageSize(90)
    }
    //call 때려
  }

  /**
   * 광고상품 선택
   * @param type
   */
  const handleChangeProductType = (type) => {
    setSearchState({
      ...searchState,
      productType: type.value
    })
  }
  /**
   * 디바이스 타입 선택
   * @param type
   */
  const handleChangeDeviceType = (type) => {
    setSearchState({
      ...searchState,
      deviceType: type.value
    })
  }

  if (modern) {
    const selectedMediaOption = mediaOptions.find(option =>
        option.value === (modernMediaInfo?.id || modernMediaInfo?.username)
    ) || mediaOptions[0];

    const handleModernMediaChange = option => {
      const nextMediaInfo = option?.data || {};
      setModernMediaInfo(nextMediaInfo);
      setSearchState(prev => ({...prev, inventoryId: null}));
      onMediaDraftChange?.(nextMediaInfo);
    };

    const handleModernDateChange = ({startDate: nextStartDate, endDate: nextEndDate}) => {
      setSearchState(prev => ({
        ...prev,
        searchStartDate: nextStartDate,
        searchEndDate: nextEndDate,
      }));
    };

    const handleModernReset = () => {
      const thisMonth = getThisMonth();
      setModernMediaInfo({});
      onMediaDraftChange?.({});
      setSearchState(prev => ({
        ...prev,
        productType: null,
        deviceType: null,
        inventoryId: null,
        searchStartDate: thisMonth.startDay,
        searchEndDate: getToDay(),
      }));
    };

    const handleModernApply = () => {
      const rangeDays = moment(searchState.searchEndDate)
          .diff(moment(searchState.searchStartDate), "days") + 1;
      onSearch?.({
        mediaInfo: modernMediaInfo,
        chartPageSize: Math.max(1, Math.min(rangeDays, 90)),
      });
    };

    return (
        <ModernCondition>
          <ModernGrid>
            {tokenInfoState.role !== "NORMAL" && searchMediaInfo !== undefined && (
                <ModernField>
                  <ModernLabel>매체사</ModernLabel>
                  <Select
                      styles={modernSelectStyle}
                      options={mediaOptions}
                      value={selectedMediaOption}
                      onChange={handleModernMediaChange}
                      isSearchable
                      placeholder="매체사를 선택해 주세요."
                      noOptionsMessage={() => "조회된 매체사가 없습니다."}
                  />
                </ModernField>
            )}
            {showInventory && (
                <ModernField>
                  <ModernLabel>지면</ModernLabel>
                  {inventoryMulti ? (
                      <FilterCheckboxDropdown
                          options={inventoryOptions}
                          selectedValues={searchState.inventoryId
                              ? String(searchState.inventoryId).split(",").filter(Boolean)
                              : []}
                          onChange={options => setSearchState(prev => ({
                            ...prev,
                            inventoryId: options.length
                                ? options.map(option => option.value).join(",")
                                : null,
                          }))}
                          disabled={inventoryRequiresMedia && !modernMediaInfo?.id}
                          itemName="지면"
                          searchPlaceholder="지면명 검색"
                          emptyMessage="조회 가능한 지면이 없습니다."
                      />
                  ) : (
                      <Select
                          styles={modernSelectStyle}
                          options={[{value: null, label: "전체"}, ...inventoryOptions]}
                          value={[{value: null, label: "전체"}, ...inventoryOptions]
                              .find(item => item.value === searchState.inventoryId)}
                          onChange={option => setSearchState(prev => ({
                            ...prev,
                            inventoryId: option?.value || null,
                          }))}
                          isSearchable
                          placeholder="지면을 선택해주세요."
                          noOptionsMessage={() => "조회 가능한 지면이 없습니다."}
                      />
                  )}
                </ModernField>
            )}
            <ModernField>
              <ModernLabel>광고 상품</ModernLabel>
              <Select
                  styles={modernSelectStyle}
                  options={defaultCondition.productType}
                  value={defaultCondition.productType.find(item => item.value === searchState.productType)}
                  onChange={handleChangeProductType}
                  isSearchable={false}
              />
            </ModernField>
            <ModernField>
              <ModernLabel>디바이스</ModernLabel>
              <Select
                  styles={modernSelectStyle}
                  options={defaultCondition.deviceType}
                  value={defaultCondition.deviceType.find(item => item.value === searchState.deviceType)}
                  onChange={handleChangeDeviceType}
                  isSearchable={false}
              />
            </ModernField>
            <ModernField $period>
              <ModernLabel>기간</ModernLabel>
              <DashboardDateSelector
                  value={{
                    startDate: searchState.searchStartDate,
                    endDate: searchState.searchEndDate,
                  }}
                  onChange={handleModernDateChange}
              />
            </ModernField>
          </ModernGrid>
          <ModernFooter>
            <ModernGuide>조건을 설정한 뒤 적용 버튼을 눌러 보고서 데이터를 조회합니다.</ModernGuide>
            <ModernButtons>
              <ModernResetButton type="button" onClick={handleModernReset}>초기화</ModernResetButton>
              <ModernApplyButton type="button" onClick={handleModernApply} disabled={!searchState.searchEndDate}>적용</ModernApplyButton>
            </ModernButtons>
          </ModernFooter>
        </ModernCondition>
    );
  }

  return (
    <BoardSearchDetail>
      {tokenInfoState.role !== 'NORMAL' && searchMediaInfo !== undefined &&
      <RowSpan>
        <ColSpan3>
          <ColTitle><span>매체사</span></ColTitle>
          <Input
            style={{width: 300}}
            value={searchMediaInfo?.siteName || '전체'}
            readOnly
          />
          <SearchUser title={'매체 계정 검색'} onSubmit={searchMedia} btnStyle={'SearchUser'}/>
          <ResetButton onClick={searchMediaReset}>매체 전체</ResetButton>
        </ColSpan3>
      </RowSpan>
      }
      {/*line1*/}
      <RowSpan style={modalStyle && {marginTop:0}}>
        <ColSpan1>
          <ColTitle><span>광고상품</span></ColTitle>
          <Select styles={inputStyle}
            placeholder={'선택하세요'}
            value={defaultCondition.productType.find(item => item.value === searchState.productType)}
            options={defaultCondition.productType}
            onChange={handleChangeProductType}
            components={{IndicatorSeparator: () => null}}/>
        </ColSpan1>
        {/*<ColSpan1>*/}
        {/*  <ColTitle><span>타겟팅</span></ColTitle>*/}
        {/*  <Select styles={inputStyle}*/}
        {/*          placeholder={'선택하세요'}*/}
        {/*          value={defaultCondition.targetingType.find(item => item.value === searchState.targetingType)}*/}
        {/*          options={defaultCondition.targetingType}*/}
        {/*          onChange={handleChangeTargetingType}*/}
        {/*          components={{IndicatorSeparator: () => null}}/>*/}
        {/*</ColSpan1>*/}
        {/*<ColSpan1>*/}
        {/*  <ColTitle><span>외부연동 유무</span></ColTitle>*/}
        {/*  <div style={{width: '85%'}}>*/}
        {/*    <Select styles={inputStyle}*/}
        {/*            placeholder={'선택하세요'}*/}
        {/*            value={defaultCondition.exchangeSearchType.find(item => item.value === searchState.exchangeSearchType)}*/}
        {/*            options={defaultCondition.exchangeSearchType}*/}
        {/*            onChange={handleChangeExchangeSearchType}*/}
        {/*            components={{IndicatorSeparator: () => null}}/>*/}
        {/*  </div>*/}
        {/*</ColSpan1>*/}
      {/*</RowSpan>*/}
      {/*line2*/}
      {/*<RowSpan>*/}
        <ColSpan1>
          <ColTitle><span>디바이스</span></ColTitle>
          <Select styles={inputStyle}
                  placeholder={'선택하세요'}
                  value={defaultCondition.deviceType.find(item => item.value === searchState.deviceType)}
                  options={defaultCondition.deviceType}
                  onChange={handleChangeDeviceType}
                  components={{IndicatorSeparator: () => null}}/>
        </ColSpan1>
        {/*<ColSpan2 style={{width: 'calc(50% + 30px)'}}>*/}
        {/*  <ColTitle><span>에이전트</span></ColTitle>*/}
        {/*  <div>*/}
        {/*    <AgentType>*/}
        {/*      <Checkbox label={'전체'}*/}
        {/*                type={'c'}*/}
        {/*                id={'all'}*/}
        {/*                isChecked={isCheckedAll}*/}
        {/*                onChange={handleChangeCheckAll}*/}
        {/*      />*/}
        {/*      {*/}
        {/*        searchState !== undefined && defaultCondition.agentType.map( (obj, key) => {*/}
        {/*          return (*/}
        {/*            <Checkbox label={obj.label}*/}
        {/*                      type={'c'}*/}
        {/*                      id={obj.value}*/}
        {/*                      value={obj.value}*/}
        {/*                      isChecked={!!searchState.agentType.includes(obj.value)}*/}
        {/*                      onChange={handleChangeCheck}*/}
        {/*                      key={key}*/}
        {/*            />*/}
        {/*          )*/}
        {/*        })*/}
        {/*      }*/}
        {/*    </AgentType>*/}
        {/*  </div>*/}
        {/*</ColSpan2>*/}
      </RowSpan>
      {/*line3*/}
      <RowSpan>
        <ColSpan1>
          <ColTitle><span>기간</span></ColTitle>
          <div style={{width:'100%'}}>
            <DateContainer>
              <CalendarBox>
                <CalendarIcon/>
              </CalendarBox>
              <CustomDatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                maxDate={new Date()}
                onChange={(date) => setDateRange(date)}
                dateFormat="yyyy-MM-dd"
                locale={ko}
                isClearable={false}
              />
            </DateContainer>
          </div>
        </ColSpan1>
        <ColSpan2>
          <div>
            <RangePicker>
              <div onClick={() => handleRangeDate('thisMonth')} style={dayType === 'thisMonth' ? {color: `${mainColor}`, fontWeight: "bold"} : null}>이번달</div>
              <HorizontalRule style={{margin: "0 10px"}}/>
              <div onClick={() => handleRangeDate('lastMonth')} style={dayType === 'lastMonth' ? {color: `${mainColor}`, fontWeight: "bold"} : null}>지난달</div>
              <HorizontalRule style={{margin: "0 10px"}}/>
              <div onClick={() => handleRangeDate('today')} style={dayType === 'today' ? {color: `${mainColor}`, fontWeight: "bold"} : null}>오늘</div>
              <HorizontalRule style={{margin: "0 10px"}}/>
              <div onClick={() => handleRangeDate('lastDay')} style={dayType === 'lastDay' ? {color: `${mainColor}`, fontWeight: "bold"} : null}>어제</div>
              <HorizontalRule style={{margin: "0 10px"}}/>
              <div onClick={() => handleRangeDate('lastWeekDay')} style={dayType === 'lastWeekDay' ? {color: `${mainColor}`, fontWeight: "bold"} : null}>지난7일</div>
              <HorizontalRule style={{margin: "0 10px"}}/>
              <div onClick={() => handleRangeDate('lastThirtyDay')} style={dayType === 'lastThirtyDay' ? {color: `${mainColor}`, fontWeight: "bold"} : null}>지난30일</div>
              <HorizontalRule style={{margin: "0 10px"}}/>
              <div onClick={() => handleRangeDate('lastNinetyDay')} style={dayType === 'lastNinetyDay' ? {color: `${mainColor}`, fontWeight: "bold"} : null}>지난90일</div>
            </RangePicker>
          </div>
        </ColSpan2>
        <ColSpan1>
          <SearchButton onClick={()=>{
            dateRange[1] !== null ? onSearch() : confirmAlert({
              title: '알림',
              message: '검색 종료일을 선택해 주세요.',
              buttons: [
                {
                  label: '확인',
                }
              ]
            })
          }}>적용</SearchButton>
        </ColSpan1>
      </RowSpan>
    </BoardSearchDetail>
  )
}

const ModernCondition = styled.div`
  padding: 16px 18px 18px;
  background: var(--color-surface);
`;

const ModernGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 16px 18px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

const ModernField = styled.div`
  min-width: 0;
  ${({$period}) => $period && "grid-column: 1 / -1;"}

  ${({$period}) => $period && `
    .react-datepicker-wrapper input {
      border: 1px solid #cfd8e3 !important;
      box-shadow: 0 1px 2px rgba(31, 41, 55, .04);
    }

    .react-datepicker-wrapper input:hover {
      border-color: var(--color-primary-focus) !important;
    }

    .react-datepicker-wrapper input:focus {
      border-color: var(--color-primary) !important;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, .1);
    }
  `}

  @media (max-width: 620px) {
    grid-column: auto;
  }
`;

const ModernLabel = styled.label`
  display: block;
  margin-bottom: 7px;
  color: #444;
  font-size: var(--font-size-13);
  font-weight: 700;
`;

const ModernFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--color-divider);

  @media (max-width: 620px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

const ModernGuide = styled.div`
  color: #929ba5;
  font-size: var(--font-size-11);
`;

const ModernButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;

const ModernResetButton = styled.button`
  min-width: 72px;
  height: 36px;
  border: 1px solid var(--color-border-strong);
  border-radius: 7px;
  background: var(--color-surface);
  color: #66727f;
  font-size: var(--font-size-13);
  font-weight: 700;
  cursor: pointer;

  &:hover {
    border-color: var(--color-primary-border);
    background: var(--color-surface-muted);
    color: var(--color-primary-strong);
  }
`;

const ModernApplyButton = styled.button`
  min-width: 72px;
  height: 36px;
  border: 1px solid var(--color-primary);
  border-radius: 7px;
  background: var(--color-primary-soft);
  color: var(--color-primary-strong);
  font-size: var(--font-size-13);
  font-weight: 700;
  cursor: pointer;

  &:hover {
    border-color: var(--color-primary-strong);
    background: var(--color-primary-muted);
  }

  &:disabled {
    border-color: #e5e9ee;
    background: #f5f6f7;
    color: #a5adb6;
    cursor: not-allowed;
  }
`;
